import { Injectable, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class HandleErrorsService {
  private readonly authenticationService = inject(AuthenticationService);

  async init() {
    this.handleQuotaExceededError();
  }

  private handleQuotaExceededError(): void {
    Sentry.addEventProcessor((event, hint) => {
      const quotaExceededError = event.exception.values.some(
        (value) =>
          value.value.includes('QuotaExceededError') ||
          value.value.includes('exceeded the quota') ||
          value.value.includes('quota has been exceeded')
      );

      if (quotaExceededError) {
        const persistedStoreKeys = [
          'bag',
          'limitedTimeEvents',
          'goldenBomb',
          'shop-rates',
          'user',
          'global-data',
          'version',
        ];
        const persistedData: Record<string, string> = {};

        persistedStoreKeys.forEach((key) => {
          try {
            persistedData[key] = localStorage.getItem(key);
          } catch {
            persistedData[key] = 'Error reading from localStorage';
          }
        });

        hint.attachments = [{ filename: 'elfStores.txt', data: JSON.stringify(persistedData, null, 2) }];

        this.authenticationService.resetElfStores();
      }
      return event;
    });
  }
}
